export class PlanCouponValidationResult {
  isValid: boolean

  grossAmount: number

  discountAmount: number

  finalAmount: number

  errorMessage?: string

  resellerCode?: string

  resellerName?: string

  constructor(data: Partial<PlanCouponValidationResult> = {}) {
    this.isValid = data.isValid ?? false

    this.grossAmount = data.grossAmount ?? 0

    this.discountAmount = data.discountAmount ?? 0

    this.finalAmount = data.finalAmount ?? 0

    this.errorMessage = data.errorMessage

    this.resellerCode = data.resellerCode

    this.resellerName = data.resellerName
  }
}
